import React from "react";

const TermsOfService = () => (
  <div className="max-w-3xl mx-auto px-4 py-8 text-gray-900 dark:text-gray-100">
    <h1 className="text-3xl font-bold mb-6 text-center">Terms of Service</h1>
    <p className="mb-4">By using IncogJson, you agree to the following terms:</p>
    <ul className="list-disc list-inside mb-4">
      <li>IncogJson is provided as-is, without warranty of any kind.</li>
      <li>All data processing is performed locally in your browser; you are responsible for your own data security.</li>
      <li>We are not liable for any loss or damage resulting from the use of this site or its tools.</li>
      <li>Do not use this site for illegal or malicious purposes.</li>
    </ul>
    <p>If you have questions about these terms, please contact us via the feedback form on the About page.</p>
  </div>
);

export default TermsOfService;
